import Cookies from 'js-cookie';
import { up } from 'slide-element';

const dismissedAlerts = JSON.parse(Cookies.get('dismissedAlerts') || null) || [];
const $alertsContainer = document.querySelector('.alerts');
const $alerts = document.querySelectorAll('.alert');

const hideAlertsContainer = () => {
    if (!$alertsContainer) return;

    const alertIds = [...$alerts]
        .map(($alert) => $alert.dataset.id)
        .filter(Boolean);

    const allDismissed = alertIds.length > 0
        && alertIds.every((id) => dismissedAlerts.includes(id));

    $alertsContainer.style.display = allDismissed ? 'none' : 'block';
};

$alerts.forEach(($alert) => {
    const alertId = $alert.dataset.id;
    const $btnClose = $alert.querySelector('.btn-close');
    const $currentAlert = $alert;

    if (!dismissedAlerts.includes(alertId)) {
        $currentAlert.style.display = 'flex';
    }

    if (!$btnClose) return;

    $btnClose.addEventListener('click', () => {
        up($currentAlert).then(() => {
            hideAlertsContainer();
        });
        dismissedAlerts.push(alertId);
        Cookies.set('dismissedAlerts', JSON.stringify(dismissedAlerts), {
            expires: 30,
        });
    });
});

hideAlertsContainer();
